import { useIntl } from 'react-intl'

import ROUTES from '~/constants/routes'

import msg from './headerTabs.messages'

export const useHeaderTabsArray = (): Option[] => {
  const { formatMessage } = useIntl()

  const HeaderTabsArray = [
    {
      label: formatMessage(msg.dashboard),
      value: ROUTES.dashboard
    },
    {
      label: formatMessage(msg.referralsList),
      value: ROUTES.referrals
    },
    {
      label: formatMessage(msg.clinicsList),
      value: ROUTES.clinics
    }
  ]

  return HeaderTabsArray
}
